export const MAIN_BANNER_CONSTANTS = {
    CONTENT: "CONTENT",
    CONTENTS: "CONTENTS",
    E_LEARNING: "E_LEARNING",
    LEARNING: "LEARNING",
    RUBICON: "RUBICON",
    FORUM: "FORUM",
    STAR_RADAR: "STAR_RADAR",
    SURVEY: "SURVEY",
    EVENT: "EVENT",
    EXAM: "EXAM",

    DETAIL: "DETAIL",
    LIST: "LIST",
}


/*
    # linkType
{
  "CampaignImageLinkPath": [
    {
      "code": 1,
      "name": "Home",
      "translate": "code.campaignImageLinkPath.home",
      "includeSub": []
    },
    {
      "code": 2,
      "name": "Content",
      "translate": "code.campaignImageLinkPath.content",
      "includeSub": ["LIST"]
    },
    {
      "code": 3,
      "name": "eLearning",
      "translate": "code.campaignImageLinkPath.elearning",
      "includeSub": ["LIST"]
    },
    {
      "code": 4,
      "name": "Forum",
      "translate": "code.campaignImageLinkPath.forum",
      "includeSub": ["LIST", "DETAIL"]
    },
    {
      "code": 5,
      "name": "StarRadar",
      "translate": "code.campaignImageLinkPath.starradar",
      "includeSub": ["DETAIL"]
    },
    {
      "code": 6,
      "name": "Survey",
      "translate": "code.campaignImageLinkPath.survey",
      "includeSub": ["LIST", "DETAIL"]
    },
    {
      "code": 7,
      "name": "Event",
      "translate": "code.campaignImageLinkPath.event",
      "includeSub": ["DETAIL"]
    },
    {
      "code": 8,
      "name": "Exam",
      "translate": "code.campaignImageLinkPath.exam",
      "includeSub": ["LIST", "DETAIL"]
    },
    {
      "code": 9,
      "name": "Rubicon",
      "translate": "code.campaignImageLinkPath.rubicon",
      "includeSub": []
    }
  ]
}
*/